import { render, staticRenderFns } from "./STable.vue?vue&type=template&id=58fbb8ee&scoped=true"
import script from "./STable.vue?vue&type=script&lang=js"
export * from "./STable.vue?vue&type=script&lang=js"
import style0 from "./STable.vue?vue&type=style&index=0&id=58fbb8ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fbb8ee",
  null
  
)

export default component.exports